<template>
  <header ref="navbarRef" class="site-header h-20 lg:h-25">
    <nav :class="[ 'w-full h-20 lg:h-25 p-4 lg:p-5 top-0 end-0 z-20 transition-transform duration-300 bg-primary-dark', true ? 'is-sticky fixed' : 'fixed lg:absolute' ]">
      <div class="flex justify-between items-center px-3 lg:px-10 h-full">
        <ShoppingBagBtn v-if="cart.totalUniqueItems > 0" class="mr-5 lg:hidden" />
        <LanguageSwitcherBtn v-else class="mr-5 lg:hidden" />
        <Logo class="mx-auto lg:mx-0" variant="color" />
        <MobileBurgerButton class="ml-5 lg:hidden" />
        <ul class="hidden lg:flex items-center flex-shrink-0 space-s-5">
          <template v-for="{ routeCode, label, className } in visibleLinks" :key="`${routeCode}_${label}`">
            <li v-if="routeCode !== ROUTES.CODE.AUCTIONS || configs.auctionFeature" :class="className">
              <NavLink
                :href="translatePath(routeCode)"
                :aria-label="$t(label)"
                active-class="text-selected-menu-hover"
                inactive-class="text-light"
                class="no-underline font-bold flex items-center transition-colors duration-200 hover:text-selected-menu-hover focus:text-selected-menu-hover mr-5"
              >
                <span>{{ $t(label) }}</span>
              </NavLink>
            </li>
          </template>
          <li class="pr-5">
            <StockAddHeaderButton v-if="routeName.startsWith('catalogue-slug___')" />
            <AddAdButton v-else />
          </li>
          <li>
            <FavoritesButton />
          </li>
          <li>
            <NotificationsButton />
          </li>
          <li>
            <HelpButton />
          </li>
          <li>
            <ShoppingBagBtn />
          </li>
          <li v-if="auth.isLoggedIn">
            <AuthorizedMenu />
          </li>
          <li v-else>
            <JoinButton />
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { siteSettings } from "@settings/site.settings";
import { useAuthStore } from "@stores/auth";
import { useConfigStore } from '@stores/config';
import { useCartStore } from '@stores/cart';
import Logo from "@components/ui/logo";
import NavLink from "@components/ui/link/nav-link";
import AddAdButton from "@components/layout/navbar/add-ad-button";
import StockAddHeaderButton from "@components/stock/stock-add-header-button";
import AuthorizedMenu from "@components/layout/navbar/authorized-menu";
import JoinButton from "@components/layout/navbar/join-button";
import ShoppingBagBtn from "@components/cart/shopping-bag-btn";
import FavoritesButton from "@components/layout/navbar/favorites-button";
import NotificationsButton from "@components/layout/navbar/notifications-button";
import HelpButton from "@components/layout/navbar/help-button";
import MobileBurgerButton from "@components/layout/navbar/mobile-burger-button";
import LanguageSwitcherBtn from "@components/common/language-switcher-btn";

const auth = useAuthStore();
const configs = useConfigStore();
const cart = useCartStore();
const route = useRoute();

const visibleLinks = computed(() => (siteSettings.headerLinks || []).filter(
    ({ routeCode }) => routeCode !== ROUTES.CODE.CATALOGUE || configs.catalogueFeature
));

const routeName = computed(() => route?.name || '');

</script>
